import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai'
import {
  FaYoutube,
  FaFacebookSquare,
  FaInstagramSquare,
  FaBandcamp
} from 'react-icons/fa'

const Navbar = () => {

  const [nav, setNav] = useState(false)
  const [navOpacity, setNavOpacity] = useState(0)
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
    setNavOpacity(0)
  }, [location.pathname])

  useEffect(() => {
    const handleScroll = () => {
      const opacity = Math.min(window.scrollY / 240, 1)
      setNavOpacity(opacity)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleNav = () => {
    setNav(!nav)
    if (!nav) {
      document.body.classList.add("overflow-hidden")
    } else {
      document.body.classList.remove("overflow-hidden")
    }
  }



  return (
    <nav
      className={`border-b-2 ${navOpacity > 0 ? 'backdrop-blur-sm' : ''}`}
      style={{
        backgroundColor: `rgba(6, 12, 29, ${navOpacity * 0.82})`,
        borderColor: `rgba(195, 195, 195, ${(1 - navOpacity) * 0.4})`
      }}
    >
      <div className="'flex justify-between items-center h-14 max-w-[1240px] mx-auto px-4 text-[#cdc3b9]'">
        <div className="flex items-center justify-between h-14">
          <Link to="/"><h1 className='w-full text-3xl font-bold text-[#cdc3b9] m-4 uppercase'>Chance to Steal</h1></Link>
          <div className="flex space-x-4 text-[#cdc3b9]">
            <ul className='hidden md:flex uppercase'>
              {/* <li className='p-4'><Link className='hover:text-[#cdc3b9] transition-colors duration-300 transform dark:hover:text-[#4a9bad] hover:border-blue-500' to="/">Home</Link></li> */}
              <li className='p-4'><Link className='hover:text-[#cdc3b9] transition-colors duration-300 transform dark:hover:text-[#4a9bad] hover:border-blue-500' to="/Music">Music</Link></li>
              <li className='p-4'><Link className='hover:text-[#cdc3b9] transition-colors duration-300 transform dark:hover:text-[#4a9bad] hover:border-blue-500' to="/Shows">Shows</Link></li>
              <li className='p-4'><Link className='hover:text-[#cdc3b9] transition-colors duration-300 transform dark:hover:text-[#4a9bad] hover:border-blue-500' to="/Media">Media</Link></li>
            </ul>
          </div>
          <div onClick={handleNav} className='block md:hidden text-[#cdc3b9]'>
            {nav ? <AiOutlineClose size={25} /> : <AiOutlineMenu size={25} />}
          </div>
          <div className={nav ? 'fixed left-0 top-0 w-[100%] h-[100dvh] border-r text-[#cdc3b9] border-r-gray-900 bg-[#060C1D] ease-in-out duration-100' : 'fixed left-[-100%]'}>
            <div className="flex items-center justify-end h-14 px-4 ">

              {/* <h1 className='w-full text-3xl font-bold text-[#060C1D] m-4 uppercase'>Chance to Steal</h1> */}

              <div onClick={handleNav} className='block md:hidden text-[#cdc3b9]'>
                {nav ? <AiOutlineClose size={25} /> : <AiOutlineMenu size={25} />}
              </div>
            </div>

            <ul className='uppercase px-4 pt-8 pb-4 font-bebas text-5xl flex flex-col items-center gap-6'>
              <li onClick={handleNav} className='transition-all duration-300 hover:drop-shadow-[0_0_10px_rgba(156,52,214,0.9)] hover:text-white'><Link to="/">Home</Link></li>
              <li onClick={handleNav} className='transition-all duration-300 hover:drop-shadow-[0_0_10px_rgba(156,52,214,0.9)] hover:text-white'><Link to="/Music">Music</Link></li>
              <li onClick={handleNav} className='transition-all duration-300 hover:drop-shadow-[0_0_10px_rgba(156,52,214,0.9)] hover:text-white'><Link to="/Shows">Shows</Link></li>
              <li onClick={handleNav} className='transition-all duration-300 hover:drop-shadow-[0_0_10px_rgba(156,52,214,0.9)] hover:text-white'><Link to="/Media">Media</Link></li>
            </ul>
            <div className='flex justify-center w-full mx-auto text-[#cdc3b9] h-200 py-4 px-4'>
              <div className='grid grid-cols-4 mx-4'>
                <div className='w-[40px] flex justify-center'><a className='transition-all duration-300 hover:drop-shadow-[0_0_8px_rgba(156,52,214,0.9)] hover:text-white' href="https://www.facebook.com/chancetosteal"><FaFacebookSquare size={30} /></a></div>
                <div className='w-[40px] flex justify-center'><a className='transition-all duration-300 hover:drop-shadow-[0_0_8px_rgba(156,52,214,0.9)] hover:text-white' href="https://www.instagram.com/chancetosteal"><FaInstagramSquare size={30} /></a></div>
                <div className='w-[40px] flex justify-center'><a className='transition-all duration-300 hover:drop-shadow-[0_0_8px_rgba(156,52,214,0.9)] hover:text-white' href="https://www.youtube.com/@chancetosteal"><FaYoutube size={30} /></a></div>
                <div className='w-[40px] flex justify-center'><a className='transition-all duration-300 hover:drop-shadow-[0_0_8px_rgba(156,52,214,0.9)] hover:text-white' href="https://chancetosteal.bandcamp.com"><FaBandcamp size={30} /></a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
